import { Variable } from "../consent/variable.model";

export class RgpdTemplate {
    uuid?: string;
    superDocsUuid?: string;
    body?: string;
    bodyVariables?: Variable[];
    language?: string;
    type?: string;
}